import Link from "next/link";
import { VFC, Fragment, ReactNode, memo } from "react";

import { Dialog, Transition } from "@headlessui/react";

import { FaTwitter } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

type SideMenuProps = {
  side: boolean;
  closeMenu: (type: "side" | "notif") => void;
  children: ReactNode;
};

const SideMenu: VFC<SideMenuProps> = ({ side, closeMenu, children }) => {
  return (
    <Transition.Root show={side} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-20 w-screen overflow-hidden"
        onClose={() => closeMenu("side")}
      >
        <div className="fixed inset-0 w-screen overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="bg-dark dark:bg-light fixed inset-0 w-screen bg-opacity-10 backdrop-blur-sm transition-opacity dark:bg-opacity-10" />
          </Transition.Child>
          <Transition.Child
            as="div"
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-dark text-light dark:bg-light dark:text-dark pointer-events-none absolute top-4 left-4 rounded-full p-1">
              <IoClose />
            </div>
          </Transition.Child>
          <div className="fixed right-0 h-screen w-1/2 md:w-1/3 lg:w-1/4">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <ul className="shadow-dark-400 dark:shadow-light-700 bg-light dark:bg-dark flex h-full flex-col overflow-y-auto py-4 px-6 shadow-md">
                {children}
                {/* <li className="mt-3 text-sm opacity-70">
                  <a
                    className="flex items-center"
                    href="https://twitter.com/Boitorea_"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FaTwitter
                      className="mr-1"
                      style={{ color: "rgb(29, 161, 242)" }}
                    />
                    {process.env.NEXT_PUBLIC_SITE_NAME} Twitter
                  </a>
                </li> */}
                {/* <li className="text-sm opacity-70 mt-3">
                  <a
                    href="https://twitter.com/Boitorea_"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    リクエスト・フィードバック
                  </a>
                </li> */}
                {/* <li className="mt-3 text-sm opacity-70">
                  <a
                    href="https://twitter.com/Boitorea_"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    お問い合わせ
                    <span className="block md:inline">（TwitterのDM）</span>
                  </a>
                </li> */}
                <li className="mt-3 text-sm opacity-70">
                  <Link href="/privacypolicy">
                    <a>プライバシーポリシー</a>
                  </Link>
                </li>
                <li className="mt-3 text-sm opacity-70">
                  <Link href="/terms">
                    <a>利用規約</a>
                  </Link>
                </li>
                <li className="mt-3 text-sm opacity-70">
                  &copy; {new Date().getFullYear()}{" "}
                  {process.env.NEXT_PUBLIC_SITE_NAME}
                </li>
              </ul>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default memo(SideMenu);
